import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { extractCollectionData, extractItemData } from '../../models/auth/auth-session.model';
import { collectPaginatedData } from '../shared/paginated-request.util';
import { LedgerEntry, LedgerResponse, WalletInfo, WalletResponse } from '../../models/wallet/wallet.model';

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient, private authService: AuthService) {}

  getWallet(): Observable<WalletInfo> {
    return this.http
      .get<WalletResponse>(`${this.baseUrl}/wallet`, { headers: this.buildHeaders() })
      .pipe(
        map(res => extractItemData<WalletInfo>(res)),
        catchError(err => this.handleError(err))
      );
  }

  getLedger(limit = 100): Observable<LedgerEntry[]> {
    const headers = this.buildHeaders();
    return collectPaginatedData<LedgerEntry>(cursor =>
      this.http
        .get<LedgerResponse>(`${this.baseUrl}/ledger`, {
          headers,
          params: this.buildCursorParams(limit, cursor)
        })
        .pipe(catchError(err => this.handleError(err)))
    );
  }

  private buildHeaders(): HttpHeaders {
    const token = this.authService.getAccessToken();
    if (!token) {
      throw new Error('No existe una sesión activa para consultar la billetera.');
    }
    return new HttpHeaders().set('X-Auth-Signly', `Bearer ${token}`);
  }

  private buildCursorParams(limit: number, cursor?: string): HttpParams {
    let params = new HttpParams();
    if (limit) {
      params = params.set('limit', String(limit));
    }
    if (cursor) {
      params = params.set('cursor', cursor);
    }
    return params;
  }

  private handleError(error: any) {
    const message = error?.error?.message || error?.message || 'No pudimos obtener la información de la billetera.';
    return throwError(() => new Error(message));
  }
}
